export * from "./base-app-detail-history.component";
export * from "./base-app-detail-history.service";
